export class InformationController {
    /* @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    submit() {
        this.$state.go('flow');
    }
}